import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from "react";
import LargeFont from "Root/profile/components/common/LargeFont";
import RegFont from "Root/profile/components/common/RegFont";
import FlavorPreview from "../FlavorPreview";
import styles from "./styles.module.scss";
import { Link } from "react-router-dom";
import Button from "Root/profile/components/common/Button";
const updateReviewsLabel = () => {
    const reviews = document.querySelectorAll("a.text-m");
    reviews.forEach((item) => {
        const text = item.textContent;
        if (text && text.toLowerCase().indexOf("reviews") > -1) {
            const reviewsCount = text.split(" ")[0] || "";
            item.textContent = reviewsCount ? `(${reviewsCount})` : "";
        }
    });
};
const ProductTile = (props) => {
    useEffect(() => {
        setTimeout(() => {
            updateReviewsLabel();
        }, 700); // wait till render
    }, []);
    return (_jsx(_Fragment, { children: _jsxs("div", { className: styles.wrapper, children: [_jsxs(Link, { to: props.href, className: styles.product_tile, children: [_jsx("img", { className: styles.img, src: props.img, alt: props.title }), _jsx(LargeFont, { fontWeight: 400, children: props.title }), _jsx(RegFont, { color: "#707070", children: props.description })] }), _jsxs("div", { className: styles.flavorContainer, children: [props.flavors && (_jsx(FlavorPreview, { flavors: props.flavors, additional_flavor_count: props.additional_flavor_count })), _jsxs("a", { href: props.href, className: styles.product_tile, children: [_jsx("div", { className: styles.yotpo, children: _jsx(RegFont, { children: props.reviews }) }), _jsx(RegFont, { fontWeight: 400, color: "#070707", children: props.price })] })] }), props.showCta && (_jsx(_Fragment, { children: _jsx(Button, { color: "green", className: styles.cta, onClick: () => props.addToCartHelper(props.item_id), children: props.cta.copy }) }))] }) }));
};
export default ProductTile;
